/** Stable fallbacks so input selectors return the same reference for empty state (reselect dev checks). */
export const EMPTY_OBJECT: Record<string, unknown> = {};
export const EMPTY_ARRAY: unknown[] = [];
